import { colors, typography } from "../../../../../../../assets/styles/tokens";

export const CustomDot = (props: any) => {
  const { cx, cy, index, activeIndex, color } = props;
  if (cx === undefined || cy === undefined) return null;
  const isActive = activeIndex === index;

  return (
    <circle
      cx={cx}
      cy={cy}
      r={isActive ? 5 : 3}
      fill={isActive ? color : "white"}
      stroke={isActive ? "white" : color}
      strokeWidth={1}
      style={
        isActive
          ? { filter: "drop-shadow(0px 0px 4px rgba(0,0,0,0.25))" }
          : undefined
      }
    />
  );
};

export const CustomXTick = (props: any) => {
  const { x, y, payload, index, activeNote, activeIndex } = props; // ← add activeIndex
  const [day, month] = payload.value.split(" ");
  const isActiveNote = activeNote === index;
  const isActive = activeIndex === index; // ← any clicked point

  return (
    <text
      x={x}
      y={y}
      textAnchor="middle"
      fill={
        isActiveNote
          ? colors.GrayLightMode[900].$value // ← dark for note points
          : isActive
            ? colors.GrayLightMode[900].$value // ← dark for any active point
            : colors.GrayLightMode[600].$value // ← default
      }
      fontSize={typography.Size.Text.xxs.$value}
      fontWeight={
        isActive || isActiveNote
          ? typography.Font_weight.Bold.$value // ← bold for any active point
          : typography.Font_weight.Medium.$value
      }
    >
      <tspan x={x} dy="1em">
        {day}
      </tspan>
      <tspan x={x} dy="1.5em">
        {month}
      </tspan>
    </text>
  );
};
